import React from 'react';
import {Controller} from "react-hook-form";
import {currencies} from "../utils/DataList";
import {Autocomplete, TextField} from "@mui/material";
import {offerSelectPaperStyles} from "./OfferDesign";

export default function CurrencySelect({control, required = false}) {

    let defaultStatus = {code: "EUR", name: "Euro", symbol: "€"};
    if (localStorage.getItem("user-settings") !== null) {
        let userSettings = JSON.parse(localStorage.getItem("user-settings"));
        if (userSettings?.currencyCode !== "") {
            currencies.forEach((item) => {
                if (item?.code === userSettings?.currencyCode) {
                    defaultStatus = item;
                }
            })
        }
    }

    return (
        <Controller
            render={({field: {onChange, ...props}, fieldState}) => (
                <Autocomplete
                    disableClearable
                    id="currency-select"
                    isOptionEqualToValue={(option, value) => option.name === value.name}
                    getOptionLabel={(option) => option.code + " - " + option.name}
                    options={currencies}
                    fullWidth
                    slotProps={{paper: {sx: offerSelectPaperStyles}}}
                    renderInput={params => (
                        <span>
                            <TextField
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label={required ? 'Currency *' : 'Currency'}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                                size="small"
                                fullWidth
                                slotProps={{inputLabel: {shrink: true}}}
                            />
                        </span>
                    )}
                    onChange={(e, data) => onChange(data)}
                    {...props}
                />
            )}
            name="currency"
            control={control}
            rules={required ? {required: 'Please select a currency.', validate: value => !!value?.code || 'Please select a currency.'} : undefined}
            defaultValue={defaultStatus}
            onChange={([, data]) => data}
        />
    );
}
